import Header from "./components/Header";
import Footer from "./components/Footer";
import Lotaip from "./repository/Lotaip";
import Lotaip2024 from "./repository/Lotaip2024";
import Lotaip2025 from "./repository/Lotaip2025";

function App() {
  return (
    <div>
      <Header></Header>

      <div className="layout8 margin padding">
        {" "}
        <h2> Acceso a la información (LOTAIP)</h2>
        <p>
          Cumpliendo con el principio de transparencia, presentamos aquí el
          detalle de nuestro cumplimiento de las obligaciones.
        </p>{" "}
        <div className="padding">
          <Lotaip2025></Lotaip2025>
          <Lotaip2024></Lotaip2024>
          <Lotaip></Lotaip>
        </div>
      </div>

      <Footer></Footer>
    </div>
  );
}

export default App;
